import { ImageField } from '@prismicio/client';
import { OptimizedPrismicImage } from '@/components';

import staticStyles from './ourProcessPhotoCard.module.scss';

export const OurProcessPhotoCard = ({
  image,
  styles,
  isVisible,
}: {
  image: ImageField<never>;
  styles: string;
  isVisible: boolean;
}) => {
  return (
    <div
      className={`${staticStyles.card} ${styles} ${isVisible ? staticStyles.isVisible : ''}`}
    >
      <OptimizedPrismicImage field={image} />
    </div>
  );
};
